// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"logo_wrapper__2mFSQ","title":"logo_title__1Qs-B","img__wrapper":"logo_img__wrapper__b2QGW","img":"logo_img__y_t6J"};